import { Trans } from 'react-i18next'

import WarningIcon from '@/assets/images/warning.svg?react'

interface props {
  _originalStorage: number
  _selectedItemStorage: number
}

export default function WarningInfoBlock({ _originalStorage, _selectedItemStorage }: props) {
  return (
    <div className="border border-[#FFBA97] bg-[#FFF1EB] text-[#FF8447] mb-4 p-4 flex items-center space-x-2.5 rounded-lg">
      <div>
        <WarningIcon className="w-5 h-5" />
      </div>
      <div className="t-sm">
        {_originalStorage > _selectedItemStorage && (
          <Trans i18nKey="space.downgradePlanNotice">
            Downgrading plan, no refund on the price difference
          </Trans>
        )}
        {_originalStorage < _selectedItemStorage && (
          <Trans i18nKey="space.upgradePlanNotice">
            Upgrading plan, with the difference between the current and new plans prices as the
            basis for calculating the daily adjustment
          </Trans>
        )}
      </div>
    </div>
  )
}
